export const PUSH_FUNNEL = [
  { l: 'Sent',      c: '2.84M', p: 100,  col: '#B94040' },
  { l: 'Delivered', c: '2.64M', p: 93.1, col: '#5A9E78' },
  { l: 'Displayed', c: '1.98M', p: 69.7, col: '#5080B8' },
  { l: 'Opened',    c: '107K',  p: 3.78, col: '#A8883A' },
  { l: 'Converted', c: '18.4K', p: 0.65, col: '#7A6EB0' },
];

export const PUSH_STATS = [
  { v: '93.1%', l: 'Delivery Rate (Android)',  b: 'vs 99.1% iOS (APNs)',     col: '#4F9B6F' },
  { v: '67%',   l: 'Opt-in Rate (Android)',    b: 'vs 56% iOS · avg 61%',    col: '#5A9E78' },
  { v: '3.78%', l: 'CTR (Android)',            b: 'vs 3.05% iOS',            col: '#6A9AC8' },
  { v: '60%',   l: 'Impression Rate',          b: '40% muted/DND',           col: '#A07C30' },
  { v: '0.65%', l: 'Post-push Conversion',     b: 'within 24h window',       col: '#6E62A8' },
  { v: '0.02%', l: 'Provider Error Rate',      b: 'FCM · last 30d',          col: '#CC5555' },
];

export const PUSH_VOLUME = {
  labels:  ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'],
  android: [3800, 4200, 4900, 4100, 5600, 3400, 2900],
  ios:     [200,  220,  260,  210,  300,  180,  150],
};
